import {
  LayoutDashboard,
  UserPlus,
  Users,
  BadgeCheck,
  FileText,
  ShieldCheck,
  ClipboardList,
  KeyRound,
  CreditCard,
  GitBranch,
  Calendar,
  MessageSquare,
  Award,
  HeartPulse,
  Briefcase,
  Scale,
  BarChart3,
  Brain,
  TrendingUp,
} from 'lucide-react';

export const getEmployeeLifecycleNavChildren = () => [
  {
    label: 'Employee Entry, Foundation & Administration',
    icon: UserPlus,
    children: [
      { path: '/employee-lifecycle-management/dashboard', label: 'Lifecycle Dashboard', icon: LayoutDashboard },
      { path: '/employee-lifecycle-management/pre-boarding', label: 'Pre-Boarding', icon: ClipboardList },
      { path: '/employee-lifecycle-management/employee-master', label: 'Employee Master', icon: Users },
      { path: '/employee-lifecycle-management/onboarding', label: 'Joining & Onboarding', icon: BadgeCheck },
      { path: '/employee-lifecycle-management/probation-confirmation', label: 'Probation & Confirmation', icon: BadgeCheck },
      { path: '/employee-lifecycle-management/employment-administration', label: 'Employment Administration', icon: Briefcase },
      { path: '/employee-lifecycle-management/documents-records', label: 'Documents & Records', icon: FileText },
      { path: '/employee-lifecycle-management/bgv-compliance', label: 'Background Verification & Compliance', icon: ShieldCheck },
      { path: '/employee-lifecycle-management/policy-consent', label: 'Policy, Consent & Declarations', icon: ClipboardList },
      { path: '/employee-lifecycle-management/access-assets-provisioning', label: 'Access, Assets & Provisioning', icon: KeyRound },
      { path: '/employee-lifecycle-management/payroll-benefits-linkage', label: 'Payroll, Benefits & Statutory Linkage', icon: CreditCard },
      { path: '/employee-lifecycle-management/approvals-governance', label: 'Workflow, Approvals & Governance', icon: GitBranch },
    ],
  },
  {
    label: 'Employee Experience, Growth & Movement',
    icon: TrendingUp,
    children: [
      { path: '/employee-lifecycle-management/attendance-leave-time', label: 'Attendance, Leave & Time', icon: Calendar },
      { path: '/employee-lifecycle-management/performance', label: 'Performance Management', icon: BarChart3 },
      { path: '/employee-lifecycle-management/learning-linkage', label: 'Learning & Development Linkage', icon: Briefcase },
      { path: '/employee-lifecycle-management/engagement-experience', label: 'Engagement & Employee Experience', icon: MessageSquare },
      { path: '/employee-lifecycle-management/rewards-recognition', label: 'Rewards, Recognition & Incentives', icon: Award },
      { path: '/employee-lifecycle-management/career-growth', label: 'Career Growth & Development', icon: TrendingUp },
      { path: '/employee-lifecycle-management/internal-mobility', label: 'Internal Mobility & Transfers', icon: GitBranch },
      { path: '/employee-lifecycle-management/compensation-benefits', label: 'Compensation, Benefits & Revisions', icon: CreditCard },
      { path: '/employee-lifecycle-management/employee-relations', label: 'Employee Relations & Grievances', icon: Scale },
      { path: '/employee-lifecycle-management/wellbeing-support', label: 'Wellbeing & Support Services', icon: HeartPulse },
      { path: '/employee-lifecycle-management/deployment-utilization', label: 'Deployment & Utilization Linkage', icon: Briefcase },
      { path: '/employee-lifecycle-management/manager-interactions', label: 'Manager-Employee Interactions', icon: MessageSquare },
      { path: '/employee-lifecycle-management/communication-community', label: 'Communication & Community', icon: MessageSquare },
      { path: '/employee-lifecycle-management/disciplinary-actions', label: 'Disciplinary & Corrective Actions', icon: ShieldCheck },
      { path: '/employee-lifecycle-management/lifecycle-notes-history', label: 'Lifecycle Notes & History', icon: FileText },
    ],
  },
  {
    label: 'Transition, Exit & Workforce Intelligence',
    icon: Brain,
    children: [
      { path: '/employee-lifecycle-management/retention-signals', label: 'Retention & Attrition Signals', icon: BarChart3 },
      { path: '/employee-lifecycle-management/resignation-exit', label: 'Resignation & Exit Initiation', icon: GitBranch },
      { path: '/employee-lifecycle-management/notice-period', label: 'Notice Period Management', icon: Calendar },
      { path: '/employee-lifecycle-management/exit-interviews', label: 'Exit Interview & Feedback', icon: ClipboardList },
      { path: '/employee-lifecycle-management/knowledge-transfer', label: 'Knowledge Transfer & Handover', icon: FileText },
      { path: '/employee-lifecycle-management/full-final-settlement', label: 'Full & Final Settlement', icon: CreditCard },
      { path: '/employee-lifecycle-management/asset-return-access-revocation', label: 'Asset Return & Access Revocation', icon: KeyRound },
      { path: '/employee-lifecycle-management/offboarding-clearance', label: 'Offboarding Compliance & Clearance', icon: ShieldCheck },
      { path: '/employee-lifecycle-management/separation-closure', label: 'Separation Types & Closure', icon: ShieldCheck },
      { path: '/employee-lifecycle-management/alumni-rehire', label: 'Alumni & Rehire', icon: Users },
      { path: '/employee-lifecycle-management/analytics', label: 'Lifecycle Analytics & Dashboards', icon: BarChart3 },
      { path: '/employee-lifecycle-management/forecasting', label: 'Workforce Forecasting & Strategic Planning', icon: TrendingUp },
      { path: '/employee-lifecycle-management/compliance-audit', label: 'Lifecycle Compliance, Policy & Audit', icon: ShieldCheck },
      { path: '/employee-lifecycle-management/ai-insights', label: 'AI Lifecycle Intelligence', icon: Brain },
      { path: '/employee-lifecycle-management/strategic-intelligence', label: 'Strategic Workforce Lifecycle Intelligence', icon: BarChart3 },
    ],
  },
  {
    label: 'Legacy (Phase-2)',
    icon: GitBranch,
    children: [{ path: '/employee-lifecycle', label: 'Lifecycle & Approvals (Legacy)', icon: GitBranch }],
  },
];

